import React from 'react';
import { Content } from "../App";
import styled from "styled-components";

interface FooterProps {

}

const footerCardClassName = [
  'surface-card',
  'border-1',
  'border-200',
  'border-round-2xl',
  'shadow-1',
  'overflow-hidden',
].join(' ');

const Biolabel = styled.img`
  width: 100px !important;
`;

const Socials = styled.div`
  margin-top: 24px;

  a {
    color: var(--orange);
    text-decoration: none;
  }

  i {
    font-size: 2.5em;
    padding-right: 16px;
  }
`;

const Footer = (props: FooterProps) => {
  return (
    <footer className="bg-white mt-2">
      <Content>
        <div className="py-5 md:py-6">
          <div className={footerCardClassName}>
            <div className="grid m-0 align-items-stretch">
              <div className="col-12 lg:col-4 p-4 md:p-5">
                <div
                  className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-4"
                  style={{ background: 'var(--green-20)' }}
                >
                  <i className="pi pi-envelope" />
                  <span className="font-medium">Contact</span>
                </div>

                <h2 className="mt-0 mb-3 text-3xl">Groentegeweld</h2>

                <p className="line-height-3 mb-4">
                  Weeldestraat 168<br />
                  2381 Weelde
                </p>

                <div className="line-height-3 mb-4">
                  <div className="flex align-items-center gap-2 mb-2">
                    <i className="pi pi-phone color-orange" />
                    <span>Willem: +32 494 66 43 46</span>
                  </div>
                  <div className="flex align-items-center gap-2">
                    <i className="pi pi-phone color-orange" />
                    <span>Dirk: +32 489 95 51 13</span>
                  </div>
                </div>

                <div className="line-height-3 mb-4">
                  <a className="font-bold color-orange" href={'mailto:info@groentegeweld.be'}>
                    info@groentegeweld.be
                  </a>
                  <br />
                  <span>BTW BE0746.361.154</span>
                  <br />
                  <a className="font-bold color-orange" href={'/voorwaarden'}>
                    Algemene voorwaarden
                  </a>
                </div>

                <Socials className="flex align-items-center gap-2">
                  <a
                    href={'https://www.facebook.com/groentegeweld'}
                    target={'_blank'}
                    rel="noreferrer"
                    aria-label="Groentegeweld op Facebook"
                  >
                    <i className={'pi pi-facebook'} />
                  </a>
                  <a
                    href={'https://www.instagram.com/groentegeweld/'}
                    target={'_blank'}
                    rel="noreferrer"
                    aria-label="Groentegeweld op Instagram"
                  >
                    <i className={'pi pi-instagram'} />
                  </a>
                </Socials>

                <a
                  className="inline-block mt-3"
                  href={'https://integra.tuv-nord.com/other/pdfcertificates/Cert/Certout/50291_GROENTEGEW_BPD_wet_Vl_20210628_CER_Certificate_Unified_v.2_NL_7983.pdf'}
                  target={'_blank'}
                  rel="noreferrer"
                  aria-label="Biolabel certificaat"
                >
                  <Biolabel src={'biolabel.png'} alt="Biolabel" />
                </a>
              </div>

              <div className="col-12 lg:col-8 p-0">
                <img
                  src={'contact.jpg'}
                  alt={'Contact met Groentegeweld'}
                  className="block w-full h-full"
                  style={{ minHeight: '360px', objectFit: 'cover' }}
                />
              </div>
            </div>
          </div>
        </div>
      </Content>
    </footer>
  );
};

export default Footer;
